
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(ranges, percentage) {
  return { ranges, percentage };
}

const rows = [
  createData('0 a 50.000.000', '8%'),
  createData('50.000.001 a 150.000.000', '9%'),
  createData('>= 150.000.001', '10%'),
];

export default function IRPTable() {
    return (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell><strong>Renta Neta (PY₲) </strong></TableCell>
                <TableCell align="right"><strong>% que aplica</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.ranges}
                  </TableCell>
                  <TableCell align="right">{row.percentage}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
}